import React, { useEffect, useState, useRef } from 'react'; 
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import constants from '../../constants';
import VersionBox from '../../components/common/VersionBox';
import EditInput from '../../components/forms/EditInput';
import GeneralSection from '../../components/common/GeneralSection';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';

function AttendanceModule(props) {
    const [menuItem, setMenuItem] = useState({});
    const [module, setModule] = useState({});
    const showPreview = true;
    const [isLoaded, setIsLoaded] = useState(false);
	const prevProps = useRef({});

	useEffect(() => {
		if (props?.actions && props?.match?.params?.projectId) {
			const projectId = props.match.params.projectId;
			props.actions.getProjectVersion(projectId);
			props.actions.getProjectVersionModules(projectId);
			props.actions.getProjectVersionMenuItems(projectId);
			props.actions.getModuleByType(projectId, 15);
		}
	  }, [props.actions, props.match?.params?.projectId]);

    useEffect(() => {
		const prev = prevProps.current;
		const isAttendanceModule = props.modules.select?.moduleType === constants.ModuleType.find((m) => m.Name === 'Attendance')?.Id;

		if (isAttendanceModule && props.modules.select?.enabled) {
			const moduleDisabledAlert = props.alerts.data?.find((m) => m.id === 'module-disabled');
			if (moduleDisabledAlert) {
				props.actions.clearAlert('module-disabled');
			}
		}

        if (!isLoaded && isAttendanceModule && !props.modules.select?.enabled) {
			props.actions.addAlert({
				message: i18n.t('modules.attendance.error1'),
				linkText: i18n.t('enableHere'),
				link: `/projects/${props.match.params.projectId}/modules/enable-modules`,
				view: '/modules/attendance',
				type: 'warning',
				id: 'module-disabled',
			});
			setIsLoaded(true);
		}

		const menuItemsFinishedLoading = !props.menuItems.inProgress && prev.menuItems?.inProgress;
		const modulesFinishedLoading = !props.modules.inProgress && prev.modules?.inProgress;

		if (menuItemsFinishedLoading || modulesFinishedLoading) {
			const hasMenuItems = Array.isArray(props.menuItems.data) && props.menuItems.data.length > 0;
			const isModuleTypeNumber = typeof props.modules.select.moduleType === 'number';
			
			const foundMenuItem = hasMenuItems && isModuleTypeNumber
				? props.menuItems.data.find((mi) =>
					mi.type === 1 &&
					Number(mi.subType) === props.modules.select.moduleType
				) || {}
				: {};

            setMenuItem(foundMenuItem);
        }

        if (modulesFinishedLoading) {
            setModule(props.modules.select);
        }

		prevProps.current = props;
	}, [props, isLoaded]);

    function updateMenuItemFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.attendance.attendance');
        if (changedValue !== '') {
            setMenuItem((prevMenuItem) => ({
                ...prevMenuItem,
                title: changedValue,
            }));
            props.actions.updateMenuItemParameter(
                props.match.params.projectId,
                module.moduleType,
                1,
                fieldName,
                changedValue
            );
        }
    }

    let bodyForm = '';
    if (module.enabled) {
        let activeCheckin = props.modules.data.filter(
            (m) => m.moduleType === constants.ModuleType.find((mod) => mod.Name === 'Check-In')?.Id && m.enabled
        );

        bodyForm = (
            <div className="form-wrapper">
                <h1 data-qa="attendance-page-header" id="attendance-page-header">
                    {i18n.t('modules.attendance.title')}
                </h1>
                {props.flags.results?.attendance && (
                    <p
                        data-qa="attendance-page-subhead"
                        id="attendance-page-subhead"
                        className="lead"
                    >
                        {i18n.t('modules.attendance.subtitle')}
                    </p>
                )}
                <GeneralSection
                    name={i18n.t('modules.attendance.section1')}
                    sectionClass="edit-module-name module-display-settings-list"
                >
                    <div id="module-display-setting" className="module-display-setting">
                        <EditInput
                            containerId="edit-module-name"
                            containerClass="edit-module-name-wrap"
                            name="title"
                            labelText={i18n.t('name')}
							value={menuItem?.title || ''}
                            charLimit={12}
                            onBlur={updateMenuItemFromEvent}
                            onReturnDown={updateMenuItemFromEvent}
                            actionClass="edit-module-name-action"
                            placeholder={i18n.t('modules.attendance.attendance')}
                            dataqa="attendance-module-name"
                            menuTitle
                        />
                        {props.flags.results?.userSelectedIcons && (
                            <HorizontalFormContainer
                                inputClass="module-display-setting__setting"
                                title="Menu Icon"
                            >
                                <UserSelectedIconSelect
                                    id={menuItem.subType}
                                    type={menuItem.type}
                                    autoUpdate
                                />
                            </HorizontalFormContainer>
                        )}
                    </div>
                </GeneralSection>
            </div>
        );
    }

    return (
        <VersionBox
            name={props.versions.select.name}
            versionNumber={props.versions.select.version}
            saving={props.modules.inProgress}
            justSaved={props.modules.justSaved}
            menuSection="Modules"
            menuItem="AttendanceModule"
            previewCssClass="modules_attendance"
            showPreview={showPreview}
            x
        >
            <div id="attendance-module" className="content-inside">
                {bodyForm}
            </div>
        </VersionBox>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceModule);
